import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/partners/terminos-referidos")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "es",
    title: "Términos del Programa de Referidos · Shugert",
    description: "Términos que regulan el programa de partners de referidos de Shugert operado por Tech Ventures USA LLC dba Shugert Marketing.",
    path: "/es/partners/terminos-referidos",
    altPath: alternatePath("/es/partners/terminos-referidos", "en"),
    jsonLd: breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Partners de referidos", path: "/es/partners/referidos" }, { name: "Términos", path: "/es/partners/terminos-referidos" }]),
  }),
});
